module.exports = __webpack_public_path__ + "img/logo.58e02d98.png";